import React from 'react';
import Button from 'material-ui/Button';
import AbstractWidget from './AbstractWidget';
import { Typography } from 'material-ui';
import NewsItemWidget from './NewsItemWidget';
import translate from 'react-i18next/dist/commonjs/translate';
import { getNewsAsync } from '../cmsLib';

class NewsWidget extends AbstractWidget {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
        this.getNews(props.widget.numberToShow);
    }

    getLabels(labels, type) {
        if (labels) {
            return labels[type].value.replace(/(\r\n|\n|\r)/gm, '');
        }
        return null;
    }

    async getNews(numberToShow) {
        let news = [];
        try {
            news = await getNewsAsync(numberToShow);
        } catch (error) {
            news = [];
            console.error(error.message);
        }
        this.setState({
            news: news,
            loading: false,
        });

    }

    render() {
        const { parameters, t, widget } = this.props;
        let title_text = t('COMMON.NEWS');
        title_text = (title_text == 'COMMON.NEWS' ? null : title_text);
        let cmsNewsWidgetClass = widget && widget.orden === 1 ? 'cmsNewsWidgetOrder1' : 'cmsNewsWidget';

        if (widget.hidden) {
            cmsNewsWidgetClass += ' hidden';
        }
        return (this.state.news ?
            <div className={cmsNewsWidgetClass}>
                <h2>{t('PAGE_TITLES.NEWS')}</h2>
                {title_text ?
                    <Typography variant="display1" className="title">{title_text}</Typography>
                    : ''}
                <div>
                    {this.state.news.map(newsItem => {
                        return <NewsItemWidget key={newsItem.id} newsItem={newsItem} parameters={parameters} widget={widget} />;
                    })}

                    <br></br>
                    <Button
                        disabled={window.location.href.indexOf('#/preview') !== -1}
                        className='readMoreLabel' component="a" href="#/news">{t('NEWS.READ_MORE_NEWS')}</Button>
                </div>
            </div >
            : ''
        );
    }
}

export default translate('translations')(NewsWidget);


// WEBPACK FOOTER //
// ./src/cms/widgets/NewsWidget.js